import contenteditableTypes from './contenteditable-types';

export default {
  contenteditableTypes,
};
